// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3ABZB","overflowing":"ReadFullNote_overflowing__1rSjH"};